export const DEFAULT_LOCALE = 'de'
export const SUPPORTED_LOCALES = ['de', 'en']

export const API_PATH = '/api/v1/'
export const API_ENDPOINTS = {
  xards: 'xards',
  xard: 'xards/{id}',
  xardLinks: 'xards/{id}/xard_links',
  lasts: 'lasts',
  me: 'users/me',
  users: 'users',
  settings: 'settings',
  tips: 'users/me/tips',
  newSession: 'sessions/new',
  codeSession: 'sessions/{key}'
}

export const LINK_CATEGORY_ID = 17601

export const PUBLIC_ROUTE_NAMES = ['login', 'not_found']

export const ICON_FONT_KEYS = {
  beeline: 'ĕ'
}

export const PLACEHOLDER_IMAGE_URL = 'https://www.xard.eu/images/placeholder.png'

export const FILTERS = {
  my: 'me',
  open: 'offen',
  new: 'neu',
  imported: 'importiert',
  tips: 'tops',
  relevant: 'relevant',
  trend: 'trend',
  flop: 'gefloppt',
  top: 'getoppt',
  bookmark: 'gemerkt',
  checkin: 'gemacht',
  allXards: 'tops',
  twinTip: 'twintops',
  chat: 'chat',
  last: 'last',
  unknown: 'unbekannt',
  myWithTips: 'Top',
  tipFlops: 'Flops'
}
